<template>
    <v-container>  
      <!-- Diálogo -->
      <v-dialog v-model="show" :style="{ width: '25vw' }">
        <v-card>
          <v-card-title>
            <span class="text-h6">Profile Options</span>
          </v-card-title>
  
          <!-- Tabs -->
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab key="1">My Accounts</v-tab>
            <v-tab key="2">My Characters</v-tab>
            <v-tab key="3">My Network</v-tab>
          </v-tabs>
  
          <!-- Contenido de cada tab -->
          <v-tabs-items v-model="tab">
            <v-tab-item key=1>
                <v-row dense>
                    <v-col cols="4">
                    <h1>Administrar Cuenta</h1>
                    <v-form ref="accountForm" v-model="valid">
                        <!-- Cambiar Nombre de Cuenta -->
                        <v-text-field
                        v-model="userid"
                        label="Nombre de la Cuenta"
                        :rules="[rules.required, rules.minLength(3)]"
                        required
                        readonly
                        dense
                        disabled
                        ></v-text-field>
                        <!-- Cambiar Email -->
                        <v-text-field
                        v-model="email"
                        label="Correo Electrónico"
                        type="email"
                        :rules="[rules.required, rules.email]"
                        required
                        ></v-text-field>
                        <!-- Cambiar Contraseña -->
                        <v-text-field
                        v-model="password_current"
                        label="Contraseña Actual"
                        type="password"
                        :rules="[rules.required]"
                        required
                        dense
                        ></v-text-field>
                        <v-text-field
                        v-model="password_new"
                        label="Nueva Contraseña"
                        type="password"
                        :rules="[rules.required, rules.minLength(6)]"
                        required
                        dense
                        ></v-text-field>
                        <v-text-field
                        v-model="password_new_repeat"
                        label="Repetir Nueva Contraseña"
                        type="password"
                        :rules="[rules.required, rules.minLength(6), rules.passwordMatch]"
                        required
                        dense
                        ></v-text-field>
                        <!-- Botón para guardar cambios -->
                        <v-btn :disabled="!valid" color="primary" @click="updateAccount">
                        Guardar Cambios
                        </v-btn>
                    </v-form>
                    </v-col>
                </v-row>
            </v-tab-item>
  
            <v-tab-item key=2>
              <v-card-text>
                <!-- Aquí va el contenido de My Characters -->
                <p>This is the My Characters tab.</p>
              </v-card-text>
            </v-tab-item>
  
            <v-tab-item key=3>
              <v-card-text>
                <!-- Aquí va el contenido de My Network -->
                <p>This is the My Network tab.</p>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
  
          <!-- Footer del diálogo -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="Close()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  export default {
    props:[
      'id',
      'show',
      'account_id',
    ],
    data() {
      return {
        tab: 0,
        valid: false,
        registroActual: {},
        account: {
          name: '',
          password: '',
          email: ''
        },
        rules: {
          required: value => !!value || 'Este campo es requerido.',
          minLength: min => value => value.length >= min || `Mínimo ${min} caracteres.`,
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Correo electrónico inválido.'
          },
          passwordMatch: value => value === this.password_new || 'Las contraseñas no coinciden.'
        },
        userid: '',
        email: '',
        password_current: '',
        password_new: '',
        password_new_repeat: '',
      }
    },
    methods: {
      Close(){
        this.$emit('close');
      },

    },
  }
  </script>